import React from "react";
import PropTypes from "prop-types";
import Notification from "components/Notification";
import Translate from "helpers/Translate";

// Styles
import "./FileHistory.styles.scss";

function FileDetails({ fileDoc }) {
  const table = () => {
    return `<pre>${JSON.stringify(fileDoc, null, 4)}</pre>`;
  };

  return (
    <div>
      <button
        data-tip={Translate({ id: "file_info" })}
        className="btn btn-default btn-sm center text-center"
        onClick={() => Notification.alert(`${table()}`)}
      >
        <i className="fa fa-info-circle fa-lg"></i>
      </button>
    </div>
  );
}

FileDetails.propTypes = {
  fileDoc: PropTypes.object
};

export default FileDetails;
